import { atom } from 'infrastructure/state/jotai.wrapper'
import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'
import { byStringFieldSort } from '../Helpers'
import { doIngestionQueries } from 'shared/api/ingestion'
import { IQueryInfo } from 'infrastructure/api'
import { AwsContentItem, AwsListResult } from 'shared/types/ingestion'

export type NewTreeData = {
  title: string
  id: number
  tree_id: string
  tree_version: string
}

export const newTreesAtom = atom<NewTreeData[]>([])

export const partnerIdAtom = atom('')

export const sourceFilesAtom = atomWithRefresh<Promise<AwsContentItem[]>>(
  async (get) => {
    const partnerId = get(partnerIdAtom)
    if (!partnerId) return []
    return queryFiles(partnerId, 'sourceFiles')
  },
)

export const ingestedFilesAtom = atomWithRefresh(async (get) => {
  const partnerId = get(partnerIdAtom)
  if (!partnerId) return []
  const fileFilter = (f: AwsContentItem) =>
    !!f.key && !f.key.includes(partnerId)
  const ingested = await queryFiles(partnerId, 'ingestedFiles')
  return ingested
    .filter(fileFilter)
    .sort(byStringFieldSort('last_modified'))
    .reverse()
})

function queryInfoForFiles(partnerKey: string, fileKey: string): IQueryInfo {
  return {
    resourceData: {
      key: fileKey,
      fields: ['name', { contents: ['key', 'URL', 'last_modified'] }],
    },
    params: {
      partner_key: partnerKey,
    },
  }
}

async function queryFiles(
  partnerKey: string,
  fileKey: 'ingestedFiles' | 'sourceFiles',
): Promise<AwsContentItem[]> {
  const query = queryInfoForFiles(partnerKey, fileKey)
  const { data } = await doIngestionQueries<AwsListResult>([query], true)
  return data[fileKey].contents
}
